import { Breadcrumb, Container } from "react-bootstrap";
import React from "react";
import home from "../../assets/images/homelink.svg";
import { useNavigate } from "react-router-dom";

function BreadcrumbsNav({ pageNav }) {
  const navigate = useNavigate();
  return (
    <Container
      fluid={true}
      className="p-0 main-top-section d-flex justify-content-between"
    >
      <Breadcrumb className="align-items-center d-flex h-100 bread-crumb-main">
        <Breadcrumb.Item
          onClick={() => navigate("/dashboard")}
          className="align-items-center d-flex"
        >
          <img src={home} alt="home" />
        </Breadcrumb.Item>
        <Breadcrumb.Item
          onClick={() => navigate("/management-listing", { state: "profile" })}
          className="align-items-center d-flex"
        >
          <span>| Settings</span>
        </Breadcrumb.Item>
        {pageNav && (
          <Breadcrumb.Item
            // active={page_item.active}
            // onClick={() => navigate(page_item.link)}
            className="align-items-center d-flex text-capitalize "
          >
            <div className="d-flex">
              {pageNav?.supportTag && (
                <span>
                  <span style={{ fontWeight: "400", color: "#666666" }}></span>{"| "}
                  {pageNav?.supportTag}
                </span>
              )}
              {pageNav?.tagName && (
                <p className="p-0 ps-1 m-0">
                 <span style={{ fontWeight: "400", color: "#666666" }}>{"| "}</span> 
                  {pageNav?.tagName}
                </p>
              )}
            </div>
          </Breadcrumb.Item>
        )}
      </Breadcrumb>
    </Container>
  );
}

export default BreadcrumbsNav;
